import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
import config from '@/config'
const title = config.title

export default new Router({
  routes: [
    {
      path: '*',
      redirect: '/'
    }, {
      path: '/',
      name: 'PageView',
      component: resolve => require(['@/view/PageView'], resolve),
      children: [
        {
          path: '/',
          redirect: '/companyintroduction'
        }, {
          path: '/home',
          name: 'home',
          component: resolve => require(['@/view/HomePage'], resolve),
          meta: {
            title: title + '-首页'
          }
        }, {
          path: '/companyintroduction',
          name: 'companyintroduction',
          component: resolve => require(['@/view/CompanyIntroduction'], resolve),
          meta: {
            title: title + '-公司介绍'
          }
        }, {
          path: '/product',
          name: 'product',
          component: resolve => require(['@/view/Product'], resolve),
          meta: {
            title: title + '-产品中心'
          },
          children: [
            {
              path: '/product',
              redirect: '/product/productTemp'
            },
            {
              path: '/product/productTemp',
              name: 'product',
              component: resolve => require(['@/view/Product_temp'], resolve),
              meta: {
                title: '设备产品丨温度传感',
                activeMenu: '/product/productTemp'
              }
            },
            {
              path: '/product/productVibration',
              name: 'product',
              component: resolve => require(['@/view/Product_vibration'], resolve),
              meta: {
                title: '设备产品丨振动传感',
                activeMenu: '/product/productVibration'
              }
            },
            {
              path: '/product/productStress',
              name: 'product',
              component: resolve => require(['@/view/Product_stress'], resolve),
              meta: {
                title: '设备产品丨应变传感',
                activeMenu: '/product/productStress'
              }
            }
          ]
        }, {
          path: '/caseshow',
          name: 'caseshow',
          component: resolve => require(['@/view/CaseShow'],resolve),
          meta: {
            title: title + '-案例展示'
          }
        },  {
          path: '/solution',
          name: 'solution',
          component: resolve => require(['@/view/Solution'],resolve),
          meta: {
            title: title + '-解决方案'
          }
        }, {
          path: '/service',
          name: 'service',
          component: resolve => require(['@/view/Service'], resolve),
          meta: {
            title: title + '-相关服务'
          }
        }, {
          path: '/newsinformation',
          name: 'newsinformation',
          component: resolve => require(['@/view/NewsInformation'], resolve),
          meta: {
            title: title + '-新闻动态'
          }
        }, {
          path: '/newsinformationdetail',
          name: 'newsinformationdetail',
          component: resolve => require(['@/view/NewsInformationDetail'], resolve),
          meta: {
            title: title + '-新闻详情'
          }
        }, {
          path: '/jobchance',
          name: 'jobchance',
          component: resolve => require(['@/view/JobChance'], resolve),
          meta: {
            title: title + '-工作机会'
          }
        }, {
          path: '/contactus',
          name: 'contactus',
          component: resolve => require(['@/view/ContactUs'], resolve),
          meta: {
            title: title + '-联系我们'
          }
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js